/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateDocumentResponse interface.
 */
export function instanceOfUpdateDocumentResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    return true;
}
export function UpdateDocumentResponseFromJSON(json) {
    return UpdateDocumentResponseFromJSONTyped(json, false);
}
export function UpdateDocumentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'documentId': json['documentId'],
    };
}
export function UpdateDocumentResponseToJSON(json) {
    return UpdateDocumentResponseToJSONTyped(json, false);
}
export function UpdateDocumentResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'documentId': value['documentId'],
    };
}
